import React from 'react';
import { Select } from 'antd';
export interface LecturerGubunSelectBox {
  lecturerGubun: string|undefined;
  onLecturerGubun: (value: string) => void;
}

const LecturerGubun = ({
  lecturerGubun,
  onLecturerGubun
}: LecturerGubunSelectBox): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <Select 
      style={{width:"100px"}} 
      value={lecturerGubun}
      placeholder="강사구분"
      onSelect={onLecturerGubun}
      options={[
        {
          value: 'A',
          label: '전체',
        },
        {
          value: 'OUT',
          label: '외부강사',
        },
        {
          value: 'IN',
          label: '내부강사',
        },   
      ]}
    /> 
  );
};

export default LecturerGubun;
